import router from './';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import store from '@/store';
import { Message } from 'element-ui';

NProgress.configure({ showSpinner: false });

const whiteList = ['/login'];

router.beforeEach(async (to, from, next) => {
  NProgress.start();
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  let accountId = store.state['user'].userInfo.accountId;
  if (accountId) {
    next();
    // 判定权限)
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      await store.dispatch('user/refreshUserInfo');
      accountId = store.state['user'].userInfo.accountId;
      if (!accountId) {
        Message.error('登录信息已过期，请重新登录');
        next(`/login?redirect=${to.path}`);
      } else {
        next();
      }
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});
